export const SECTION_META = {
  dashboard: {
    eyebrow: 'Overview',
    title: 'Subscription dashboard',
    description: 'Monitor your plan, billing cycle, and token usage in one place.',
  },
  plans: {
    eyebrow: 'Billing',
    title: 'Plans & pricing',
    description:
      'Simple, transparent USD pricing — Community Edition, Professional, and Enterprise plans aligned with candorsys.com.',
  },
  addons: {
    eyebrow: 'Add-ons',
    title: 'Token add-ons',
    description: 'Purchase additional tokens when you need more capacity.',
  },
  billing: {
    eyebrow: 'Finance',
    title: 'Billing history',
    description: 'Review invoices and download receipts from Paddle.',
  },
  settings: {
    eyebrow: 'Account',
    title: 'Settings',
    description: 'Manage appearance and account preferences.',
  },
};
